<template>
  <dx-data-grid
    ref="dataGridRef"
    :allow-column-reordering="true"
    :column-chooser="{ enabled: true, mode: 'select' }"
    :column-min-width="50"
    :columns="columns"
    :data-source="dataSource"
    :filter-row="{ visible: true }"
    :header-filter="{ visible: true }"
    :height="50"
    :hover-state-enabled="true"
    :repaint-changes-only="true"
    :row-alternation-enabled="true"
    :show-borders="true"
    :show-column-lines="true"
    :width="'100%'"
    :word-wrap-enabled="true"
    style="flex-grow: 1"
    value-expr="id"
    @toolbar-preparing="onToolbarPreparing($event)"
    @cell-dbl-click="openDetail($event)"
    @content-ready="onContentReady($event)"
  >
    <dx-paging :enabled="true" :page-size="40" />
    <dx-load-panel :enabled="true" />
    <dx-scrolling mode="virtual" />
    <dx-sorting mode="single" />
    <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />

    <template #filterTemplateDepartment>
      <span>Подразделение</span>
      <mped-department-tree-component
        ref="departmentTree"
        :default-value="defaultValues.department"
        :validate-code="false"
        @value-changed="changedFilter($event, 'department')"
      />
    </template>

    <template #filterTemplatePeriod>
      <span>Период</span>
      <mped-calculation-period-component
        :default-value="defaultValues.periods"
        :default-period="'current'"
        @value-changed="changedFilter($event, 'periods')"
      />
    </template>

    <template #filterTemplateActivity>
      <ai-drop-down-tab
        :choose-all="true"
        :columns="[{ caption: 'Вид деятельности', dataField: 'name' }, { caption: 'Код', dataField: 'code', width: 80 }]"
        :displayTotal="true"
        :get-data-source="getCalculationActivity"
        drop-down-height="50vh"
        drop-down-width="500"
        key-expr="id"
        placeholder="Вид деятельности"
        valueExpr="name"
        @value-changed="changedFilter($event, 'activities')"
        :default-value="defaultValues.activities"
      />
    </template>

    <template #filterTemplateSubjects>
      <ai-drop-down-tab
        :choose-all="true"
        :columns="[{ caption: 'Субъект РФ', dataField: 'subject_name' }, { caption: 'Код', dataField: 'kod_subj', width: '80' }]"
        :displayTotal="true"
        :get-data-source="getCountrySubjects"
        drop-down-height="auto"
        drop-down-width="500"
        key-expr="kod_spr_subj"
        placeholder="Субъект РФ"
        valueExpr="subject_name"
        @value-changed="changedFilter($event, 'subjects')"
        :default-value="defaultValues.subjects"
      />
    </template>

    <template #filterTemplateType>
      <ai-drop-down-tab
        :columns="[{ caption: 'Код', dataField: 'name'}]"
        :displayTotal="false"
        :get-data-source="getCalculationArticleType"
        :show-column-headers="false"
        :default-value="defaultValues.mode"
        :show-filter-row="false"
        :show-clear-button="false"
        drop-down-height="auto"
        drop-down-width="300px"
        key-expr="id"
        placeholder="Режим просмотра данных"
        selection-mode="single"
        valueExpr="name"
        @value-changed="changedFilter($event, 'mode')"
      />
    </template>

    <template #headerCellTemplate="{ data: headerInfo }" >
      <div class="w-100 d-flex">
        <i :class="expandClass[headerInfo.column.dataField]" @click="collapseColumn($event, headerInfo.column.dataField)"></i>
      </div>
    </template>

  </dx-data-grid>

  <footer-grid :show-selected-counter="false" :totalCount="totalCount" class="px-2"></footer-grid>
</template>

<script>
export default {
  name: 'mped-calculation-analysis-article-view',
};
</script>


<script setup>
import { ref, onBeforeMount, onMounted } from 'vue';
import {
  DxDataGrid,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxExport,
  DxPaging,
} from 'devextreme-vue/data-grid';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import MpedCalculationPeriodComponent
  from '@/views/mped/views/calculation/component/mped-calculation-period-component.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';
import {
  getCalculationActivity,
  getCalculationArticle,
  getCalculationArticleDetail,
  getCalculationArticleType,
} from '@/views/mped/services/mped-calculation-api-service';
import { getCountrySubjects } from '@/views/mped/services/mped-department-service';
import MpedDepartmentTreeComponent from '@/views/mped/views/calculation/component/mped-department-tree-component.vue';
import AiDropDownTab from '@/components/ai-drop-down-tab/ai-drop-down-tab.vue';
import { getColumns } from '@/views/mped/services/mped-calculation-service';
import { appName, baseUrl } from '@/views/mped/services/mped-service';
import { useRoute, useRouter } from 'vue-router';
import { getLocalUserdata, initState, setLocalUserdata } from '@/service/local-userdata-service';

const route = useRoute();
const router = useRouter();
const totalCount = ref(0);
const columns = getColumns('article');
const dataGridRef = ref();
const filter = ref({});
const expandClass = ref({
  total_op: 'dx-icon dx-icon-minus',
  total_vp: 'dx-icon dx-icon-minus',
  total_opr: 'dx-icon dx-icon-minus',
  total_ohr: 'dx-icon dx-icon-minus'
});
let
    lastFilter,
    defaultValues = {
      periods: null,
      department: -1,
      subjects: null,
      activities: null,
      mode: 0
    };
let focusedCellTarget = null;

const dataSource = getAiDataSource(
  {
    dataFn: getCalculationArticle,
    key: 'id',
    validationFn: () => {
      return filter.value.periods && filter.value.department;
    },
    paramsFn: () => {
      lastFilter = Object.assign({}, {
        periods: filter.value.periods.map(x => Number(x)),
        departmentId: filter.value.department.kod_direct,
        subjects: filter.value.subjects,
        activities: filter.value.activities,
        mode: filter.value.mode
      });
      return lastFilter;
    },
    onLoadedFn: (data) => {
      totalCount.value = data.totalCount;
      focusCell();
    }
  },
);

onBeforeMount(async () => {
  const state = getLocalUserdata(router);
  if (state) {
    ['department', 'periods', 'activities', 'mode', 'subjects'].forEach(x => {
      defaultValues[x] = state.filters[x];
    });
  }
});

onMounted(async () => {
  initState(router, dataGridRef);
});

const onToolbarPreparing = (e) => {
  e.toolbarOptions.elementAttr = {
    class: 'ai-toolbar-row-with-label',
  };

  const filters = [{
    location: 'before',
    template: 'filterTemplateDepartment',
  }, {
    location: 'before',
    template: 'filterTemplatePeriod',
  }, {
    location: 'before',
    template: 'filterTemplateActivity',
  }, {
    location: 'before',
    template: 'filterTemplateSubjects',
  }, {
    location: 'before',
    template: 'filterTemplateType',
  }];

  getAiToolbar(e, {
    customs: filters,
    refresh: {
      event: reloadData,
    },
  });
};

const reloadData = async () => {
  setState();
  dataSource.reload();
};

const changedFilter = (e, filed) => {
  filter.value[filed] = e;
};

const collapseColumn = (e, dataField) => {
  let visible = true;
  e.stopImmediatePropagation();
  let classButton = 'dx-icon dx-icon-';
  if (expandClass.value[dataField].includes('plus')) {
    classButton = classButton + 'minus';
  } else {
    classButton = classButton + 'plus';
    visible = false;
  }

  expandClass.value[dataField] = classButton;
  const column = columns.find(c => c.columns?.find(x => x.dataField === dataField));
  column.columns.forEach(x => {
    if (x.dataField !== dataField)
      x.visible = visible;
  });
  dataGridRef.value.instance.option('columns', columns);
}

const openDetail = (e) => {
  if (e.rowType === 'data') {
    const { id: rowId } = e.data;
    const column = e.column.dataField;
    focusCell(e);
    getCalculationArticleDetail({ rowId, column, ...lastFilter}).then(data => {
      const guid = data.processGuid;
      const { app, dep } = route.params;
      if (guid)
        window.open(`/${baseUrl}/${appName}/calculation-analysis-detail/&/${app}/${dep}/${guid}/${getCaptionDetail(e)}`);
    });
  }
};

const focusCell = (e) => {
  if (focusedCellTarget)
    focusedCellTarget.classList.remove('calculation-report-text-focused')

  if (e) {
    focusedCellTarget = e.event.target;
    focusedCellTarget.classList.add('calculation-report-text-focused')
  }
}
const getCaptionDetail = (e) => {
  const parentColumn = columns.find(c => c.columns?.find(x => x.dataField === e.column.dataField));
  const captionPath = [filter.value.department.name, filter.value.periods, e.row.data['name']];
  if (parentColumn?.caption)
    captionPath.push(parentColumn?.caption);
  captionPath.push(e.column.caption);

  return captionPath.join('; ').replaceAll('/', '-');
}

const onContentReady = e => {
  setState();
}

const setState = () => {
  setLocalUserdata(router, dataGridRef, filter.value);
}

</script>

<style>

.calculation-report-text-focused {
  font-weight: bold !important;
  color: green;
}

</style>
